import { render, staticRenderFns } from "./DatatableVehicle.vue?vue&type=template&id=ffc7a72c"
import script from "./DatatableVehicle.vue?vue&type=script&lang=js"
export * from "./DatatableVehicle.vue?vue&type=script&lang=js"
import style0 from "./DatatableVehicle.vue?vue&type=style&index=0&id=ffc7a72c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports